export default "__VITE_ASSET__BHldZ4im__"